import { createAction } from 'Lib/reduxUtils';

import {
  RESET_LINE_TOKEN_STATE,
  RETRIEVE_LINE_TOKEN_ERROR,
  VALIDATE_LINE_TOKEN_ERROR,
  VALIDATE_LINE_TOKEN_SUCCESS,
} from './constants';

export const validateLineTokenSuccess = createAction(VALIDATE_LINE_TOKEN_SUCCESS);
export const validateLineTokenError = createAction(VALIDATE_LINE_TOKEN_ERROR);
export const resetLineTokenState = createAction(RESET_LINE_TOKEN_STATE);
export const retrieveLineTokenError = createAction(RETRIEVE_LINE_TOKEN_ERROR);
